// Imágenes de la landing de Il Kit dell'Animatore. Las páginas de la galería son páginas reales del kit, en Recursos de la tienda (Impultienda).
export interface GalleryItem {
  title: string
  caption: string
  image: string
}

const R = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ea2f3273-0302-4b11-9cf3-6458d9c8bb1a/'

export const gallery: GalleryItem[] = [
  {
    title: 'Volume 1 · Il barattolo della gratitudine',
    caption: "L'incontro intero passo dopo passo: obiettivo, tempo, materiali, svolgimento, Parola, domande, preghiera e sfida.",
    image: R + '1793776640317_vol1-idea-02-abd00828.jpg',
  },
  {
    title: 'Volume 2 · Due verità e una bugia',
    caption: 'Un gioco per cominciare, con il suo messaggio, un brano della Bibbia e una domanda finale.',
    image: R + '1793776649446_vol2-gioco-01-48e0ff6f.jpg',
  },
  {
    title: 'Volume 3 · Confrontarsi con gli altri sui social',
    caption: 'Un incontro già scritto sulla vita vera dei ragazzi, minuto per minuto.',
    image: R + '1793776673947_vol3-incontro-02-19dda1ae.jpg',
  },
  {
    title: 'Volume 1 · Caccia al tesoro biblica in oratorio',
    caption: 'Un incontro in movimento che avvicina il gruppo alla Parola.',
    image: R + '1793776664707_vol1-idea-23-ce75b618.jpg',
  },
  {
    title: 'Volume 2 · Il ponte di giornali',
    caption: 'Collaborazione a squadre, poi la condivisione: cosa ci unisce a Dio e agli altri?',
    image: R + '1793776686136_vol2-gioco-17-88d7759b.jpg',
  },
  {
    title: 'Volume 1 · Ritiri e uscite',
    caption: 'Programmi pronti ora per ora, dalla giornata di spiritualità al weekend.',
    image: R + '1793817647765_vol1-idea-38-kit-c2ff02fa.jpg',
  },
]

// Mockup del kit (5 volumi + 5 bonus), en Recursos de la tienda.
export const heroImage = R + '1793819559636_mockup-kit-animatore-v2-46fda41a.jpg'
